// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media only screen and (min-width:960px){.business-swiper[data-v-223672cf].swiper-wrapper{margin-left:-20px!important}}.geo-city-main-content[data-v-223672cf]{padding-bottom:70px;padding-top:70px}.livestream-container[data-v-223672cf]{transition:margin-top .5s}.livestream-container--offset[data-v-223672cf]{margin-top:-100px}@media only screen and (min-width:960px){.livestream-container--offset[data-v-223672cf]{margin-top:-140px}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
